import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotificationService } from "./notification.service";
import { NotificationModel } from "./notification.model"; 
import { Subscription } from "rxjs"; 
import { Router } from '@angular/router';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})

export class NotificationComponent implements OnInit, OnDestroy { 
  notifications: NotificationModel[] = [];
  private _subscription: Subscription;

  constructor(private _notificationSvc: NotificationService, 
    private router: Router) { }
 
  private _addNotification(notification: NotificationModel) {
    this.notifications.push(notification);

    if (notification.timeout !== 0) {
      setTimeout(() => this.close(notification), notification.timeout);
    }
  }

 ngOnInit() { 
    this._subscription = this._notificationSvc.getObservable().subscribe(notification => this._addNotification(notification));
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  close(notification: NotificationModel) {
    this.notifications = this.notifications.filter(notif => notif.uid !== notification.uid);
  } 

  goUrl(notification: NotificationModel) { 
    if(notification.url != ""){
      this.router.navigateByUrl(notification.url); //al pulsar aqui, enviar peticion para marcar como leida 
    }
  }  
  public trackByIndex(i: number) { return i; }

}